import { render, staticRenderFns } from "./companyCard1.vue?vue&type=template&id=5f41a541&scoped=true"
import script from "./companyCard1.vue?vue&type=script&lang=js"
export * from "./companyCard1.vue?vue&type=script&lang=js"
import style0 from "./companyCard1.vue?vue&type=style&index=0&id=5f41a541&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f41a541",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f41a541')) {
      api.createRecord('5f41a541', component.options)
    } else {
      api.reload('5f41a541', component.options)
    }
    module.hot.accept("./companyCard1.vue?vue&type=template&id=5f41a541&scoped=true", function () {
      api.rerender('5f41a541', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/companyCard1.vue"
export default component.exports